export const ID_KEY = 'id';

export const REAL_FULL_NAME_KEY = 'real_full_name';

export const REAL_IIN_KEY = 'real_iin';
